import LoandSideBar from "../LoansSideBar"
import loanCss from "../../../css/overview.module.css"
import React from 'react';
import { Doughnut, Bar } from 'react-chartjs-2';
import { useState, useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';

import Select from "react-select";
import { toast } from "react-toastify";

import {ReactComponent as FilterIcon} from "../../../assets/icons/filter.svg"
import {ReactComponent as Plus} from "../../../assets/icons/plus.svg"
import {ReactComponent as CalenderIcon} from "../../../assets/icons/calenderIcon.svg"
import {ReactComponent as CustModeLCloseIcon }  from '../../../assets/icons/custModeLCloseIcon.svg'
import {ReactComponent as LoansUploadIcon }  from '../../../assets/icons/loansUploadIcon.svg'
import {ReactComponent as RemoveLoanIcon }  from '../../../assets/icons/removeLoansIcons.svg'

import { UploadLoanFiles, GetLoanMapping,
         saveLoanMapping, GetSubLoanMapping, submapping, getLoansData,
         getAllLoansErpData, putLoanFromERP } from '../../../../Bookclosure/Services/ApiHandler'
import AddLoanRegister from "../AddLoanRegister/AddLoanRegister";
import ERPModal from "../ERPModal/ERPModal";
import SyncERPSuccess from "../../../fixedassetelements/SyncButton/SyncERPSuccess";
import ErrorPopup from "../../../elements/ErrorPopup";
import SuccessPopup from "../../../elements/SuccessPopup";

const LoanOverView = () => {

    const { id, companyId } = useParams();

    const [loanID, setloanID] = useState(id)
    const [loansUploadModal,setLoanUploadModal] = useState(false)
    const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
    const [showERPModal, setShowERPModal] = useState(false);
    const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
    const [erpList, setErpList] = useState([]);
    const [selectedCardId, setSelectedCardId] = useState(null);
    const [isErpLoading, setIsErpLoading] = useState(false);
    const [errorPopup, setErrorPopup] = useState({ isOpen: false, title: "Error", message: "" });
    const [successPopup, setSuccessPopup] = useState({ isOpen: false, title: "Success", message: "" });
    
    // loan Mapping model
    const [loanMapping,setloanMapping] = useState(false)
    
    // loan Mapping model
    const [subloanMapping,setsubloanMapping] = useState(false)

    const [loansColumnMapVal, setloansColumnMapVal] = useState({}); // Initialize to an empty object
    const [loansColumnMap, setloansColumnMap] = useState([])
    
    const [subMappingActiveTab, setsubMappingActiveTab] = useState(1)
    
    const [perIndAsLabels, setperIndAsLabels] = useState()
    const [perIndAsFields, setperIndAsFields] = useState()
    
    const [perRBILables, setperRBILables] = useState()
    const [perRBIFields, setperRBIFields] = useState()

    const [perProductClassfLables, setperProductClassfLables] = useState()
    const [perProductClassfFields, setperProductClassfFields] = useState()

    const [selectedSubMappingData, setSelectedSubMappingData] = useState({
        RBIStages: [],
        IndASStages: [],
        productClassificationStages: []
    });

    

    const handleSetSelectChange = (selectedOption, index, tab) => {
        let label = '';
        if (tab === 'IndAS') label = perIndAsLabels[index];
        else if (tab === 'RBI') label = perRBILables[index];
        else if (tab === 'productClassification') label = perProductClassfLables[index];

        setSelectedSubMappingData(prev => {
            const updated = [...prev[tab + 'Stages']];
            updated[index] = {
            key: label || '', // ensure key is always set
            values: [selectedOption.value]
            };
            return {
            ...prev,
            [tab + 'Stages']: updated
            };
        });
    };


    useEffect(() => {
        setloansColumnMapVal({
            // Basic Customer and Loan Identifiers
            "customerID": "CustomerID3",                      // Maps to Excel column: CustomerID3
            "customerName": "ApplicantName3",                 // Maps to Excel column: ApplicantName3
            "productID": "Product  ID3",                      // Maps to Excel column: Product  ID3
            "productName": "Product name",                    // Maps to Excel column: Product name
            "loanID": "LegacyID",                             // Maps to Excel column: LegacyID
            "loanName": "LegacyID",                           // Same as loanID
            "sanctionAmount": " Cumm_Sanction_Amt ",          // Maps to Excel column with spaces
            "sanctionDate": "Sanc. Date",                     // Maps to: Sanc. Date
            "sanctionedROI": " Sanction_ROI ",                // Maps to: Sanction_ROI
            "currentOrRevisedROI": " Revised_ROI ",           // Maps to: Revised_ROI
            "sanctionedNumberOfMonths": "Sanction_Term",      // Maps to: Sanction_Term
            "remainingNumberOfMonths": " Revised_Term ",      // Maps to: Revised_Term
            "overdueDays": "OD days after link",              // Maps to: OD days after link
            "loanOutstanding": " Final Loan O/s ",            // Maps to: Final Loan O/s
            "principalOverdue": " OD_PRN ",                   // Maps to: OD_PRN
            "interestOrPEMIOverdue": " OD_INT ",              // Maps to: OD_INT

            // Processing Fees
            "processingFeesCollected": "Processing fees collected",      // Maps to: Processing fees collected
            "indASProcessingFees": " Ind AS processing fees ",           // Maps to: Ind AS processing fees

            // Classifications
            "assetClassificationRBI": "Asset classification as per RBI",        // Maps to: Asset classification as per RBI
            "assetClassificationIndAS": "Asset classification as per Ind AS",  // Maps to: Asset classification as per Ind AS

            // Provisioning
            "provisionPercentageRBI": "Provision % as per RBI",         // Maps to: Provision % as per RBI
            "provisionPercentageIndASPD": "PD",                         // Maps to: PD
            "provisionPercentageIndASLGD": "LGD",                       // Maps to: LGD
            "provisionAmountRBI": "Provison amount as per RBI",         // Maps to: Provison amount as per RBI
            "provisionAmountIndASLGD": " Provison amount as per Ind AS ", // Maps to: Provison amount as per Ind AS
            "outstandingIndAS": " Outstanding as per Ind AS ",          // Maps to: Outstanding as per Ind AS
            "outstandingUndrawnCommitment": " O/s Undrawn commitment ", // Maps to: O/s Undrawn commitment
            "provisionAmountUndrawnCommitment": " Provision on undrawn commitment ", // Maps to: Provision on undrawn commitment
            "cumulativeDisbursement": "Cummulative disbursement",       // Maps to: Cummulative disbursement

            "bifurcation": "Loan - Bifurcation (Amortized cost/FVOCI)*",
            "collateralType": "Collateral type*",
            "collateralAmount": "Collateral amount*",
            "fairValueCollateralAmount": "Fair value of Collateral amount*",
            "industryClassification": "Industry classification*",
            "sectorClassification": "Sector wise classification*",
            "outstandingWriteOff": "O/s Write off",
            "ECLWriteOff": "ECL Write off"
        })
    }, [])
               
    
        const fileInputRef = useRef(null);
        const handleManualUpload = () => {
            fileInputRef.current.click();
        };
    
        // arranging data in to object to send api
        const handleSelectChange = (keyName, selectedOption) => {
            // keyName will be "customerID", "customerName", "productID", etc.
            // selectedOption will be the object from react-select (e.g., { value: "Actual Excel Column Name", label: "Actual Excel Column Name" })
    
            setloansColumnMapVal(prevMapping => ({
                ...prevMapping, // Keep all the previous key-value pairs
                [keyName]: selectedOption ? selectedOption.value : '' // Update only the specific key with the new selected value
            }));
        };
    
       
        // getting loans data
        const GetLoanMappingData = () => {
            GetLoanMapping(loanID).then((res) => {
                let loansFieldsLst = res.data.fields
        
                // Map loan list to dropdown format
                const formattedOptions = loansFieldsLst.map(loansFieldsLst => ({
                    value: loansFieldsLst,
                    label: loansFieldsLst
                }));
        
                setloansColumnMap(formattedOptions);
                setloanMapping(true)
    
            })
        }
    
    
         // sending loans mapping object
        const saveColumnMapping = () => {
            saveLoanMapping(loanID,loansColumnMapVal).then(res => {
                // hide the loan mapping
                setloanMapping(false)
                
                // get the sub mapping data 
                GetSubLoanMappingData()
    
                // un hide the sub loan mapping
                setsubloanMapping(true)
            })
        }
    
    
        // getting sub Mapping data
        const GetSubLoanMappingData = () => {
    
            GetSubLoanMapping(loanID, 'IndAS').then((res) => {
                let loansFieldsLst = res.data.fields
                let labelList = res.data.labelList
        
                // Map loan list to dropdown format
                const formattedOptions = loansFieldsLst.map(loansFieldsLst => ({
                    value: loansFieldsLst,
                    label: loansFieldsLst
                }));
        
                setperIndAsFields(formattedOptions);
                setperIndAsLabels(labelList)
            })
    
            GetSubLoanMapping(loanID, 'RBI').then((res) => {
                let loansFieldsLst = res.data.fields
                let labelList = res.data.labelList
        
                // Map loan list to dropdown format
                const formattedOptions = loansFieldsLst.map(loansFieldsLst => ({
                    value: loansFieldsLst,
                    label: loansFieldsLst
                }));
        
                setperRBIFields(formattedOptions);
                setperRBILables(labelList)
            })
    
            GetSubLoanMapping(loanID, 'productClassification').then((res) => {
                let loansFieldsLst = res.data.fields
                let labelList = res.data.labelList
        
                // Map loan list to dropdown format
                const formattedOptions = loansFieldsLst.map(loansFieldsLst => ({
                    value: loansFieldsLst,
                    label: loansFieldsLst
                }));
        
                setperProductClassfFields(formattedOptions);
                setperProductClassfLables(labelList)
                setsubloanMapping(true)
            })
    
        }
    
        const saveSubMapping = () => {
            submapping(loanID, selectedSubMappingData).then(res => {
                setsubloanMapping(false)
                getLoanDt()
                toast.success("Loans add successfully.");
            })
        }

    const [overViewtotalOutstanding, setoverViewtotalOutstanding] = useState()
    const [overViewtotalLoans, setoverViewtotalLoans] = useState()
    const [overViewoutstandingByValueChart, setoverViewoutstandingByValueChart] = useState()
    const [overViewoutstandingByLoanChart, setoverViewoutstandingByLoanChart] = useState()
    const [overViewsanctionedAndDisbursementChart, setoverViewsanctionedAndDisbursementChart] = useState({
        labels: [],
        datasets: []
    });


    const [TotalOutstandingValue, setTotalOutstandingValue]  = useState()
    const [TotalOutstandingLoan, setTotalOutstandingLoan] = useState()

    const [valueChartLegend, setValueChartLegend] = useState([]);
    const [loanChartLegend, setLoanChartLegend] = useState([]);

    const [indAsImpact, setindAsImpact] = useState(false)

    useEffect(() => {
        getLoanDt()
    } 
    ,[])

    const getLoanDt = () => {
        getLoansData(loanID).then(res => {
            const totalOutstanding = res?.data?.loan?.totalOutstanding;
                setoverViewtotalOutstanding(
                totalOutstanding ? Number(totalOutstanding).toLocaleString() : '0'
            );

            const loanValue = res?.data?.loan?.totalLoans;
                setoverViewtotalLoans(
                loanValue ? Number(loanValue).toLocaleString() : '0'
            );


            const valueChart = res.data.loan?.outstandingByValueChart || [];
            const loanChart = res.data.loan?.outstandingByLoanChart || [];

            const totalValue = valueChart.reduce((sum, item) => sum + item.value, 0);
            const totalLoan = loanChart.reduce((sum, item) => sum + item.value, 0);
            const colorsLst = [
                '#94E0AE', '#61CBDB', '#639FF0',
                '#FFD6E0', '#D4C1EC', '#BFF5FF',
                '#FDE2B6', '#BCEBCB', '#E8DAFF', '#FFC9B9' ]

            setoverViewoutstandingByValueChart({
            labels: valueChart.map(item => item.label),
            datasets: [{
                label: 'Outstanding loan composition by value',
                data: valueChart.map(item => item.value),
                backgroundColor: colorsLst,
                hoverOffset: 4
            }]
            });

            setoverViewoutstandingByLoanChart({
            labels: loanChart.map(item => item.label),
            datasets: [{
                label: 'Outstanding loan composition by loans',
                data: loanChart.map(item => item.value),
                backgroundColor: colorsLst,
                hoverOffset: 4
            }]
            });

            setTotalOutstandingValue(
                totalValue ? Number(totalValue).toLocaleString() : '0'
            );

            setTotalOutstandingLoan(
                totalLoan ? Number(totalLoan).toLocaleString() : '0'
            );


            const valueLegend = valueChart.map((item, index) => ({
            label: item.label,
            color: colorsLst[index]
            }));

            const loanLegend = loanChart.map((item, index) => ({
            label: item.label,
            color: colorsLst[index]
            }));

            setValueChartLegend(valueLegend);
            setLoanChartLegend(loanLegend);

            const barColors = [
            '#94E0AE', '#F6C858', '#639FF0', '#FFD6E0', '#D4C1EC',
            '#BFF5FF', '#FDE2B6', '#BCEBCB', '#E8DAFF', '#FFC9B9'
            ];

            const apiData = res.data.loan?.sanctionedAndDisbursementChart || [];

            const barChartData = {
                labels: ['Sanction', 'Disbursement'],
                datasets: apiData.map((item, index) => ({
                    label: item.label || `Label ${index + 1}`,
                    data: [
                    item.value?.sanctioned || 0,
                    item.value?.disbursement || 0
                    ],
                    backgroundColor: barColors[index % barColors.length],
                    borderWidth: 0,
                    borderRadius: 5,
                    barThickness: 75
                }))
                };

            setoverViewsanctionedAndDisbursementChart(barChartData);

        })
    }

    const handleSelect = async (type) => {
        if (type === "uploadExcelModal") {
            setShowAddRegisterModal(false);
            setLoanUploadModal(true);
        } else if (type === "erp") {
            setShowAddRegisterModal(false);
            setShowERPModal(true);
            setIsErpLoading(true);
            try {
                const res = await getAllLoansErpData(loanID);
                const list =
                    res.data?.ERPLoanList ||
                    res.data?.ERPLoansList ||
                    res.data?.data ||
                    (Array.isArray(res.data) ? res.data : []);
                setErpList(list);
            } catch (error) {
                console.error("Failed to fetch ERP loans:", error);
                setErpList([]);
            } finally {
                setIsErpLoading(false);
            }
        }
    };

    const handleSuccessERPModal = async () => {
        if (!selectedCardId) {
            setErrorPopup({
                isOpen: true,
                title: "Selection Required",
                message: "Please select an ERP package to proceed.",
            });
            return;
        }
        try {
            const selectedItem = (erpList || [])
                .flatMap((pkg, pkgIdx) => {
                    if (Array.isArray(pkg.data) && pkg.data.length > 0) {
                        return pkg.data.map((entry, entryIdx) => ({
                            ...entry,
                            _id: entry._id || `${pkg._id || pkgIdx}-${entryIdx}`,
                            packageId: pkg._id || pkg.id,
                        }));
                    }
                    return [pkg];
                })
                .find(
                    (i) =>
                        i._id === selectedCardId ||
                        i.packageId === selectedCardId ||
                        i.id === selectedCardId
                );

            const resolvedPackageId =
                selectedItem?.packageId || selectedItem?._id || selectedCardId;

            await putLoanFromERP(loanID, resolvedPackageId);
            setShowERPModal(false);
            setSelectedCardId(null);
            setShowERPSuccessModal(true);
        } catch (error) {
            console.error("Failed to pull from ERP:", error);
            setErrorPopup({
                isOpen: true,
                title: "Error",
                message:
                    error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    "Failed to pull ERP data. Please try again.",
            });
        }
    };

    const handleERPComplete = () => {
        setShowERPSuccessModal(false);
        getLoanDt();
    };

    const [amountIn, setAmountIn] = useState({
        value: 'whole Numbers',  
        label: 'whole Numbers'
    });

    const [showDataIn, setshowDataIn] = useState({
        value: 'Charts',  
        label: 'Charts'
    });

    return(
        <div style={{ display: 'flex' }}>
            <LoandSideBar 
                id = {id}
                companyId={companyId}
                activeTab={'Overview'}
            />
            <div className={loanCss.loanListingMainContainer}>
                <LoanListingHeader 
                    setLoanUploadModal = {setLoanUploadModal}
                    setShowAddRegisterModal = {setShowAddRegisterModal}
                    indAsImpact={indAsImpact}
                    setindAsImpact={setindAsImpact}
                />
                <div className={`${loanCss.WarapperContainer} ${loanCss.customscroll}`}>
                    <div className={loanCss.sticyWrapper}>
                        <Stats 
                            overViewtotalOutstanding={overViewtotalOutstanding}
                            overViewtotalLoans={overViewtotalLoans}
                            overViewoutstandingByValueChart={overViewoutstandingByValueChart}
                            overViewoutstandingByLoanChart={overViewoutstandingByLoanChart}
                            overViewsanctionedAndDisbursementChart={overViewsanctionedAndDisbursementChart}
                            showDataIn={showDataIn}
                            setshowDataIn={setshowDataIn}
                            amountIn={amountIn}
                            setAmountIn={setAmountIn}
                        />
                    </div>
                    <div>
                        <ChartsContainer 
                            overViewtotalOutstanding={overViewtotalOutstanding}
                            overViewtotalLoans={overViewtotalLoans}
                            overViewoutstandingByValueChart={overViewoutstandingByValueChart}
                            overViewoutstandingByLoanChart={overViewoutstandingByLoanChart}
                            overViewsanctionedAndDisbursementChart={overViewsanctionedAndDisbursementChart}
                            TotalOutstandingValue={TotalOutstandingValue}
                            TotalOutstandingLoan={TotalOutstandingLoan}
                            valueChartLegend={valueChartLegend}
                            loanChartLegend={loanChartLegend}
                        />
                    </div>
                </div>
            
                {showAddRegisterModal && (
                    <AddLoanRegister
                        onClose={() => setShowAddRegisterModal(false)}
                        handleSelect={handleSelect}
                    />
                )}

                {showERPModal && (
                    <ERPModal
                        erpList={erpList}
                        selectedCardId={selectedCardId}
                        setSelectedCardId={setSelectedCardId}
                        isLoading={isErpLoading}
                        onClose={() => {
                            setShowERPModal(false);
                            setSelectedCardId(null);
                        }}
                        onBack={() => {
                            setShowERPModal(false);
                            setSelectedCardId(null);
                            setShowAddRegisterModal(true);
                        }}
                        onProceed={handleSuccessERPModal}
                    />
                )}

                {showERPSuccessModal && (
                    <SyncERPSuccess onClose={handleERPComplete} />
                )}

                {loansUploadModal &&(
                    <React.Fragment>
                        <LoansUploadModel 
                            fileInputRef={fileInputRef}
                            handleManualUpload={handleManualUpload}
                            setLoanUploadModal = {setLoanUploadModal}
                            loanID={loanID}
                            setloanMapping={setloanMapping}
                            GetLoanMappingData={GetLoanMappingData}
                        />
                    </React.Fragment>
                )}

                {loanMapping &&(
                    <React.Fragment>
                        <LoansMappingModel 
                            loansColumnMap={loansColumnMap}
                            loansColumnMapVal={loansColumnMapVal}
                            setloansColumnMapVal={setloansColumnMapVal}
                            handleSelectChange={handleSelectChange}
                            saveColumnMapping={saveColumnMapping}
                            setloanMapping={setloanMapping}
                        />
                    </React.Fragment>
                )}
                {subloanMapping &&(
                    <React.Fragment>
                        <SubLoansMappingModel 
                            subloanMapping={subloanMapping}
                            setsubloanMapping={setsubloanMapping}
                            subMappingActiveTab={subMappingActiveTab} 
                            setsubMappingActiveTab={setsubMappingActiveTab}
                            perIndAsLabels={perIndAsLabels}
                            perIndAsFields={perIndAsFields}
                            perRBILables={perRBILables}
                            perRBIFields={perRBIFields}
                            perProductClassfLables={perProductClassfLables}
                            perProductClassfFields={perProductClassfFields}
                            handleSetSelectChange={handleSetSelectChange}
                            selectedSubMappingData={selectedSubMappingData} 
                            setSelectedSubMappingData={setSelectedSubMappingData}
                            saveSubMapping={saveSubMapping}
                        />
                    </React.Fragment>
                )}

                <SuccessPopup
                    isOpen={successPopup.isOpen}
                    title={successPopup.title}
                    message={successPopup.message}
                    onClose={() =>
                        setSuccessPopup({ isOpen: false, title: "Success", message: "" })
                    }
                />

                <ErrorPopup
                    isOpen={errorPopup.isOpen}
                    title={errorPopup.title}
                    message={errorPopup.message}
                    onClose={() =>
                        setErrorPopup({ isOpen: false, title: "Error", message: "" })
                    }
                />

            </div>
        </div>
    )
}

export default LoanOverView;


const Stats = ({
    overViewtotalOutstanding,
    overViewtotalLoans,
    overViewoutstandingByValueChart,
    overViewoutstandingByLoanChart,
    overViewsanctionedAndDisbursementChart,
    showDataIn,
    amountIn,
}) => {
    
    return(
        <div className={loanCss.statsMainContainer}>
            <div className={`${loanCss.statBox} ${loanCss.statCard1}`}>
                <div className={loanCss.statText}>{overViewtotalLoans}</div>
                <div className={loanCss.statSubText}>Total Loans</div>
            </div>
            <div className={`${loanCss.statBox} ${loanCss.statCard2}`}>
                <div className={loanCss.statText}>{overViewtotalOutstanding}</div>
                <div className={loanCss.statSubText}>Loans O/S Amount</div>
            </div>
            <div className={`${loanCss.statBox} ${loanCss.statCard3}`}>
                <div className={`${loanCss.selectCon} ${loanCss.carbMb}`}>
                    <div className={loanCss.selectLabel}>Amount in </div>
                    <div className={loanCss.selectWrapper}>
                        <Select
                            components={{ IndicatorSeparator: () => null }} // remove separator
                            value={amountIn}
                            options={[amountIn]}
                            placeholder="Select amount type"
                            name="status"
                            className={`mt-0 ${loanCss.scenarioSelect}`}
                            classNamePrefix="select"
                            styles={customStyles}
                            isClearable={false}
                            isSearchable={false}
                        />
                    </div>
                </div>
                <div className={loanCss.selectCon}>
                    <div className={loanCss.selectLabel}>Show data in </div>
                    <div className={loanCss.selectWrapper}>
                        <Select
                            components={{ IndicatorSeparator: () => null }} // remove separator
                            value={showDataIn}
                            options={[showDataIn]}
                            placeholder="Select view type"
                            name="viewType"
                            className={`mt-0 ${loanCss.scenarioSelect}`}
                            classNamePrefix="select"
                            styles={customStyles}
                            isClearable={false}
                            isSearchable={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
};


const LoansUploadModel = ({
    setLoanUploadModal,
    fileInputRef,
    handleManualUpload,
    loanID,
    setloanMapping,
    GetLoanMappingData
}) => {
    const [dragActive, setDragActive] = useState(false);
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false); // New state for tracking upload status
    const [uploadError, setUploadError] = useState(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
    }
  };

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleRemoveFile = () => {
        setFile(null);
        // Crucial fix: Clear the input's value to allow re-uploading the same file
        if (fileInputRef.current) {
            fileInputRef.current.value = null; // or ''
        }
    };

    const uploadFileToApi = async () => {
        if (!file) {
            setUploadError("Please select a file to upload.");
            return;
        }

        if (!loanID) {
            setUploadError("Loan ID is missing. Cannot upload file.");
            return;
        }

        setUploading(true);
        setUploadError(null);

        const formData = new FormData();
        formData.append('file', file); // Key 'file' matches your Postman setup and backend expectation

        try {
            // Call your API function
            const result = await UploadLoanFiles(loanID, formData); // Pass loanID and formData
            console.log('Upload successful:', result);
            GetLoanMappingData()
            setLoanUploadModal(false)

        } catch (error) {
            // Error handling from the API call
            console.error('Error uploading file:', error);
            // Check if error.response exists for more specific API error messages
            const errorMessage = error.response && error.response.data && error.response.data.message
                                 ? error.response.data.message
                                 : error.message || 'An unexpected error occurred during upload.';
            setUploadError(errorMessage);
        } finally {
            setUploading(false);
        }
    };

  return (
    <div
      className={`${loanCss.cutModelForDragLaonsIrac} custmfadein`}
      onClick={() => {
        setLoanUploadModal(false);
      }}
    >
      <div
        className={loanCss.cutmModelMainContainer}
        onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
      >
        <div className={loanCss.custModelHeader}>
          <div className={loanCss.custModelHeaderLabel}>Map Column headers</div>
          <div className={loanCss.custmCursor}>
            <CustModeLCloseIcon
              className={`${loanCss.custModelHeaderCloseicon} ${loanCss.cursiorPointer}`}
              onClick={() => setLoanUploadModal(false)}
            />
          </div>
        </div>

        <div className={loanCss.cutModelBodyContainerOne}>
          <div
            className={`${loanCss.dragDropArea} ${dragActive ? loanCss.dragActive : ''}`}
            onDragEnter={handleDrag}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}
          >
            <label htmlFor="file-upload" className={loanCss.dragDropLabel}>
              Drag and drop your file here or
              <button type="button" 
                onClick={handleManualUpload}
                className={loanCss.custModelUploadBtn}>
                    <LoansUploadIcon className={loanCss.loanUploadIcon} />
                    &nbsp; 
                    Upload
              </button>
            </label>
            <input
                id="file-upload"
                type="file"
                onChange={handleFileChange}
                className={loanCss.hiddenFileInput}
                ref={fileInputRef}
            />
          </div>

          <div className={loanCss.loanUploadInfo}>
            File you upload must contain all the mandatory fields for mapping.
            {/* Display upload error message */}
            {uploadError && (
                <p style={{ color: 'red', marginTop: '10px' }}>{uploadError}</p>
            )}

          </div>

          {file && (
            <p className={`${loanCss.selectedFile} ${loanCss.fileUploadedIcon}`}>
              File Name  {file.name} 
              <span className={loanCss.fileRmIcon}
                onClick={() => {
                    // setFile(null)
                    handleRemoveFile();
                }}
            > 
                <RemoveLoanIcon /> 
            </span>
            </p>
          )}
        </div>

        <div className={loanCss.cutModelFooterContainer}>
          <button
            type="button"
            onClick={() => setLoanUploadModal(false)}
            className={loanCss.custModelFooterBtnSecondary}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={uploadFileToApi}
            className={loanCss.custModelFooterBtnPrimary}
            disabled={uploading || !file || !loanID} // Disable if no file or no loanID
        >
            {uploading ? 'Uploading...' : 'Proceed'}
        </button>
        </div>
      </div>
    </div>
  );
};


const LoanListingHeader = ({
        setLoanUploadModal,
        setShowAddRegisterModal,
        indAsImpact,
        setindAsImpact,
    }) => {
    return(
        
        <div className={loanCss.w100}>

            <div className={loanCss.uploadLoansMainContainer}>
            
            </div>

            <div className={loanCss.listPageheader}>
                <div className={loanCss.loanHeaderLeftContainer}>
                    {/* <div className={loanCss.heading}>Loan Listing</div> */}
                </div>
                <div className={loanCss.loanHeaderRightContainer}>
                    
                    {/* <div className={loanCss.filterContainer}>
                        <FilterIcon />
                    </div> */}

                    <div className={loanCss.filterContainer}>
                        <span className="module-toggles">
                            <div className="toggle-item">
                                <div className="toggle-container">
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={indAsImpact}
                                            onChange={() => setindAsImpact(!indAsImpact)}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </span>
                        {/* &nbsp; */}
                        {/* &nbsp; */}
                        {/* Ind AS Impact */}
                        <span className={loanCss.indaslabel}>Ind AS Impact</span>
                    </div>

                    <div className={loanCss.calenderContainer}>
                        <div className={loanCss.leftCalenderContainer}>
                            <div className={loanCss.calenderLabels}>
                                From
                            </div>
                            <div className={loanCss.calenderDate}>
                                01-01-2024
                            </div>
                            <div className={loanCss.calenderIconContainer}>
                                <CalenderIcon />
                            </div>
                        </div>

                        <div className={loanCss.RightCalenderContainer}>
                            <div className={loanCss.calenderLabels}>
                                To 
                            </div>
                            <div className={loanCss.calenderDate}>
                                01-03-2024
                            </div>
                            <div className={loanCss.calenderIconContainer}>
                                <CalenderIcon />
                            </div>
                        </div>
                    </div>
                    <div className={loanCss.btnWrapper}>
                        <button
                            onClick={() => {
                                if (setShowAddRegisterModal) {
                                    setShowAddRegisterModal(true);
                                } else {
                                    setLoanUploadModal(true);
                                }
                            }} 
                            type="button" 
                            className={loanCss.uploadPrimaryBtn}> 
                            <Plus className={`${loanCss.plusIcon}`} /> 
                            {/* <span style={{ fontSize: '15px' }}>+</span>
                            &nbsp; */}
                            Upload
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
};


const ChartsContainer = ({
    overViewtotalOutstanding,
    overViewtotalLoans,
    overViewoutstandingByValueChart,
    overViewoutstandingByLoanChart,
    overViewsanctionedAndDisbursementChart,
    TotalOutstandingValue,
    TotalOutstandingLoan,
    valueChartLegend,
    loanChartLegend,
}) => {
    
    const Donutdata = {
        datasets: [{
          label: 'Outstanding loan composition by value',
          data: [100, 80, 100],
          backgroundColor: [
            '#FFE3BF',
            '#C5FFDA',
            '#C2DEFB'
          ],
          hoverOffset: 4
        }]
    };

    const BarData = {
        labels: ['Sanction', 'Disbursements'], // X-axis labels
        datasets: [
            {
                label: 'Home Loan',
                data: [6000000, 4000000], // Data for Home Loan
                backgroundColor: '#FDD09F', // Orange color
                borderWidth: 0,
                borderRadius:5,
                barThickness: 75
            },
            {
                label: 'Home Equity',
                data: [5000000, 7000000], // Data for Home Equity
                backgroundColor: '#C5FFDA', // Light green color
                borderWidth: 0,
                borderRadius:5,
                barThickness: 75
            },
        ],
    };

    const options = {
    responsive: true,
    plugins: {
        legend: { display: false },
    },
    scales: {
        x: {
        grid: { display: false },
        ticks: {
            callback: function (value) {
            const label = this.getLabelForValue(value);
            return label?.toUpperCase().split('').join('\u200A') || ''; // less space
            },
            color: '#33584E',
            font: { weight: 'bold' },
        },
        },
        y: {
        beginAtZero: true,
        ticks: {
            callback: (value) => value.toLocaleString(),
            color: '#33584E',
            font: { weight: 'bold' },
        },
        grid: {
            drawBorder: false,
            color: 'rgba(0, 0, 0, 0.05)',
        },
        },
    },
    };

    const barChartOptions =  [
        {
            value: "total",
            label: 'Total'
        },
    ];

    const [selectedBarChartOption, setSelectedBarChartOption] = useState(barChartOptions[0]);
    return(
        <React.Fragment>
            <div className={loanCss.ChartsContainerWrapper}> 
                <div className={`${loanCss.barChatContainer} ${loanCss.bgWihite} ${loanCss.pd} ${loanCss.barChatCont}`}>

                    <div className={loanCss.detailsContainer}>
                        <div className={loanCss.BarChartHeadingContainer}>
                            <div className={loanCss.BarChartHeading}>
                                Sanction and disbursement details
                            </div>
                            <div className={loanCss.barChartSelect}>
                                <Select
                                    components={{ IndicatorSeparator: () => null }} // remove separator
                                    value={selectedBarChartOption}
                                    options={barChartOptions}
                                    onChange={setSelectedBarChartOption}
                                    placeholder=""
                                    name="status"
                                    className={`mt-0 ${loanCss.scenarioSelect} ${loanCss.barChartSelectWrap}`}
                                    classNamePrefix="select"
                                    styles={customStyles}
                                    isClearable={false}
                                    isSearchable={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div>
                        <Bar 
                            data={overViewsanctionedAndDisbursementChart}
                            options={options}
                        />
                    </div>

                    <div className={loanCss.pieChartContainer}>
                        {overViewsanctionedAndDisbursementChart.datasets.map((ds, i) => (
                            <div key={i} className={loanCss.labelWrapper}>
                            <div style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                backgroundColor: ds.backgroundColor,
                                marginRight: '10px'
                            }} />
                            {ds.label}
                            </div>
                        ))}
                    </div>


                </div>

                <div className={`${loanCss.donutChartWrapper} ${loanCss.bgWihite} ${loanCss.pd}`} style={{ marginLeft: '10px' }}>
                    <div className={loanCss.detailsContainer}>
                        <div className={loanCss.chartHeadingContainer}>
                            <div className={loanCss.chartHeading}>
                                O/S Loans composition by value 
                                {/* Outstanding loan composition by value */}
                            </div>
                            <div className={loanCss.chartHeadingDate}>
                                As of 01-01-2025 &nbsp; <CalenderIcon />
                            </div>
                        </div>
                        <div className={loanCss.chartAmountContainer}>
                            <div className={loanCss.chartLoanAmount}>
                                ₹ {TotalOutstandingValue}
                            </div>
                            <div className={loanCss.amountLabel}>
                                TOTAL VALUE
                            </div>
                        </div>
                    </div>
                    <Doughnut 
                        data={overViewoutstandingByValueChart || Donutdata}
                        options={{
                            cutout: '50%', // Thicker donut (try '40%' for even thicker)
                            plugins: {
                            legend: { display: false }
                            },
                            elements: {
                            arc: {
                                borderRadius: 10, // Rounded corners
                                borderWidth: 4,   // Creates spacing between sections
                                borderColor: '#fff' // match background color
                            }
                            }
                        }}
                    />
                    <div className={loanCss.pieChartContainer}>
                        {valueChartLegend.map((item, i) => (
                            <div key={i} className={loanCss.labelWrapper}>
                            <div style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                backgroundColor: item.color,
                                marginRight: '10px'
                            }}></div>
                            {item.label}
                            </div>
                        ))}
                    </div>

                </div>
            </div>
            <div className={`${loanCss.donutChartWrapper} ${loanCss.bgWihite} ${loanCss.pd}`} style={{ marginLeft : '20px', marginTop: '20px', marginBottom: '20px' }}>
                <div className={loanCss.detailsContainer}>
                    <div className={loanCss.chartHeadingContainer}>
                        <div className={loanCss.chartHeading}>
                            O/S Loans composition by loans

                        </div>
                        <div className={loanCss.chartHeadingDate}>
                            As of 01-01-2025 &nbsp; <CalenderIcon />
                        </div>
                    </div>
                    <div className={loanCss.chartAmountContainer}>
                        <div className={loanCss.chartLoanAmount}>
                            {TotalOutstandingLoan}
                        </div>
                        <div className={loanCss.amountLabel}>
                            TOTAL VALUE
                        </div>
                    </div>
                </div>
                <Doughnut 
                        data={overViewoutstandingByLoanChart || Donutdata}
                        options={{
                            cutout: '50%', // Thicker donut (try '40%' for even thicker)
                            plugins: {
                            legend: { display: false }
                            },
                            elements: {
                            arc: {
                                borderRadius: 10, // Rounded corners
                                borderWidth: 4,   // Creates spacing between sections
                                borderColor: '#fff' // match background color
                            }
                            }
                        }}
                    />
                <div className={loanCss.pieChartContainer}>
                    {valueChartLegend.map((item, i) => (
                        <div key={i} className={loanCss.labelWrapper}>
                        <div style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: item.color,
                            marginRight: '10px'
                        }}></div>
                        {item.label}
                        </div>
                    ))}
                </div>
            </div>
        </React.Fragment>
    )
}



const LoansMappingModel = ({
    loansColumnMap,
    loansColumnMapVal,
    setloansColumnMapVal,
    handleSelectChange,
    saveColumnMapping,
    setloanMapping
}) => {

    return (
        <div
            className={`${loanCss.cutModelForDragLaonsIrac} custmfadein`}
            onClick={() => {}}>
            <div
                className={loanCss.cutmModelMainContainerSecond}
                onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
                >
                <div className={loanCss.custModelHeader}>
                    <div className={loanCss.custModelHeaderLabel}>Map Column headers</div>
                    <div className={loanCss.custmCursor}>
                        <CustModeLCloseIcon
                        className={`${loanCss.custModelHeaderCloseicon} ${loanCss.cursiorPointer}`}
                        onClick={() => {setloanMapping(false);}}
                        />
                    </div>
                </div>

                <div className={`${loanCss.cutModelBodyContainer} ${loanCss.customscroll}`}>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Customer ID
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                // value={loansColumnMapVal?.val ? loansColumnMap.find(option => option.value === loansColumnMapVal?.val) : ''}
                                value={loansColumnMapVal['customerID'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['customerID']) : null}
                                onChange={(selectedOption) => handleSelectChange('customerID', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Customer Name
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['customerName'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['customerName']) : null}
                                onChange={(selectedOption) => handleSelectChange('customerName', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Product ID
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['productID'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['productID']) : null}
                                onChange={(selectedOption) => handleSelectChange('productID', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Product name
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['productName'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['productName']) : null}
                                onChange={(selectedOption) => handleSelectChange('productName', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Loan ID
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['loanID'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['loanID']) : null}
                                onChange={(selectedOption) => handleSelectChange('loanID', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Loan Name
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['loanName'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['loanName']) : null}
                                onChange={(selectedOption) => handleSelectChange('loanName', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Sanction Amount
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['sanctionAmount'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['sanctionAmount']) : null}
                                onChange={(selectedOption) => handleSelectChange('sanctionAmount', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Sanction Date
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['sanctionDate'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['sanctionDate']) : null}
                                onChange={(selectedOption) => handleSelectChange('sanctionDate', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Sanction ROI
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['sanctionedROI'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['sanctionedROI']) : null}
                                onChange={(selectedOption) => handleSelectChange('sanctionedROI', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Current/Revised ROI
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['currentOrRevisedROI'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['currentOrRevisedROI']) : null}
                                onChange={(selectedOption) => handleSelectChange('currentOrRevisedROI', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Sanctioned no.of months
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['sanctionedNumberOfMonths'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['sanctionedNumberOfMonths']) : null}
                                onChange={(selectedOption) => handleSelectChange('sanctionedNumberOfMonths', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Remaining no.of months
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['remainingNumberOfMonths'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['remainingNumberOfMonths']) : null}
                                onChange={(selectedOption) => handleSelectChange('remainingNumberOfMonths', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Overdue Days
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['overdueDays'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['overdueDays']) : null}
                                onChange={(selectedOption) => handleSelectChange('overdueDays', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Loan Outstanding
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['loanOutstanding'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['loanOutstanding']) : null}
                                onChange={(selectedOption) => handleSelectChange('loanOutstanding', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Principle Overdue
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['principalOverdue'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['principalOverdue']) : null}
                                onChange={(selectedOption) => handleSelectChange('principalOverdue', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Interest/PEMI overdue
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['interestOrPEMIOverdue'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['interestOrPEMIOverdue']) : null}
                                onChange={(selectedOption) => handleSelectChange('interestOrPEMIOverdue', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Processing fee collected
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['processingFeesCollected'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['processingFeesCollected']) : null}
                                onChange={(selectedOption) => handleSelectChange('processingFeesCollected', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Ind AS processing fees O/s
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['indASProcessingFees'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['indASProcessingFees']) : null}
                                onChange={(selectedOption) => handleSelectChange('indASProcessingFees', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Asset Classification as per RBI
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['assetClassificationRBI'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['assetClassificationRBI']) : null}
                                onChange={(selectedOption) => handleSelectChange('assetClassificationRBI', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Asset Classification as per Ind AS
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['assetClassificationIndAS'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['assetClassificationIndAS']) : null}
                                onChange={(selectedOption) => handleSelectChange('assetClassificationIndAS', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Provision % as per RBI
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['provisionPercentageRBI'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionPercentageRBI']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionPercentageRBI', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Outstanding as per Ind AS
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['outstandingIndAS'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['outstandingIndAS']) : null}
                                onChange={(selectedOption) => handleSelectChange('outstandingIndAS', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Provision % as per Ind AS - PD
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['provisionPercentageIndASPD'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionPercentageIndASPD']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionPercentageIndASPD', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Provision Amount as per RBI
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['provisionAmountRBI'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionAmountRBI']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionAmountRBI', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Provision on undrawn commitment
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['outstandingUndrawnCommitment'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['outstandingUndrawnCommitment']) : null}
                                onChange={(selectedOption) => handleSelectChange('outstandingUndrawnCommitment', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  O/s Undrawn Commitment
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['provisionAmountUndrawnCommitment'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionAmountUndrawnCommitment']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionAmountUndrawnCommitment', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Cumulative Disbursement
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['cumulativeDisbursement'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['cumulativeDisbursement']) : null}
                                onChange={(selectedOption) => handleSelectChange('cumulativeDisbursement', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                             <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Provision % as per Ind AS - LGD
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['provisionPercentageIndASLGD'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionPercentageIndASLGD']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionPercentageIndASLGD', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Collateral type
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['collateralType'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['collateralType']) : null}
                                onChange={(selectedOption) => handleSelectChange('collateralType', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Industry classification
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['industryClassification'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['industryClassification']) : null}
                                onChange={(selectedOption) => handleSelectChange('industryClassification', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Provision amount as per Ind AS - LGD
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['provisionAmountIndASLGD'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionAmountIndASLGD']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionAmountIndASLGD', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Collateral amount
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['collateralAmount'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['collateralAmount']) : null}
                                onChange={(selectedOption) => handleSelectChange('collateralAmount', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Sector wise classification
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['sectorClassification'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['sectorClassification']) : null}
                                onChange={(selectedOption) => handleSelectChange('sectorClassification', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Loan - Bifurcation (Amortized cost/FVOCI)
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['bifurcation'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['bifurcation']) : null}
                                onChange={(selectedOption) => handleSelectChange('bifurcation', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  Fair value of Collateral amount
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['fairValueCollateralAmount'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['fairValueCollateralAmount']) : null}
                                onChange={(selectedOption) => handleSelectChange('fairValueCollateralAmount', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  O/s Write off
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['outstandingWriteOff'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['outstandingWriteOff']) : null}
                                onChange={(selectedOption) => handleSelectChange('outstandingWriteOff', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                  ECL Write off
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={loansColumnMapVal['ECLWriteOff'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['ECLWriteOff']) : null}
                                onChange={(selectedOption) => handleSelectChange('ECLWriteOff', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Column"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>
                
                </div>

                <div className={loanCss.cutModelFooterContainer}>
                    <button
                        type="button"
                        onClick={() => {setloanMapping(false);}}
                        className={loanCss.custModelFooterBtnSecondary}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        onClick={() => {saveColumnMapping()}}
                        className={loanCss.custModelFooterBtnPrimary}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
  );
};



const SubLoansMappingModel = ({
    setsubloanMapping,
    subloanMapping,
    subMappingActiveTab, 
    setsubMappingActiveTab,
    perIndAsLabels,
    perIndAsFields,
    perProductClassfLables,
    perProductClassfFields,
    perRBILables,
    perRBIFields,
    handleSetSelectChange,
    selectedSubMappingData, 
    setSelectedSubMappingData,
    saveSubMapping
    }) => {

    return (
        <div
            className={`${loanCss.cutModelForDragLaonsIrac} custmfadein`}
            onClick={() => {}}>
            <div
                className={loanCss.cutmModelMainContainerThird}
                onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
                >
                <div className={loanCss.custModelHeader}>
                    <div className={loanCss.custModelHeaderLabel}>Sub Mapping</div>
                    <div className={loanCss.custmCursor}>
                        <CustModeLCloseIcon
                        className={`${loanCss.custModelHeaderCloseicon} ${loanCss.cursiorPointer}`}
                        onClick={() => {setsubloanMapping(false)}}
                        />
                    </div>
                </div>

                {/* subMappingActiveTab, setsubMappingActiveTab */}
                <div className={loanCss.wrapperContainerSubMap}>
                    <div className={loanCss.loansSubMapTabsContainer}>
                        <div onClick={() => {setsubMappingActiveTab(1)}} className={ subMappingActiveTab === 1 ? loanCss.subMapTabsActive : loanCss.subMapTabs }>Asset Classification as per RBI</div>
                        <div onClick={() => {setsubMappingActiveTab(2)}} className={ subMappingActiveTab === 2 ? loanCss.subMapTabsActive : loanCss.subMapTabs }>Asset Classification as per Ind AS</div>
                        <div onClick={() => {setsubMappingActiveTab(3)}} className={ subMappingActiveTab === 3 ? loanCss.subMapTabsActive : loanCss.subMapTabs }>Product Classification</div>
                    </div>
                    {
                        subMappingActiveTab === 1 ?  
                            <div className={`${loanCss.selectContainerWrapper} ${loanCss.customscroll}`}>
                                {perRBILables?.map((label, index) => (
                                    <div className={loanCss.selectContainerTab} key={index}>
                                        <div style={{ marginBottom:'10px' }}>{label}</div>
                                        <Select
                                            components={{ IndicatorSeparator: () => null }} // remove separator
                                            key={index}
                                            value={selectedSubMappingData.RBIStages[index]?.values?.[0] 
                                                ? { label: selectedSubMappingData.RBIStages[index].values[0], value: selectedSubMappingData.RBIStages[index].values[0] }
                                                : null
                                            }
                                            onChange={(selectedOption) => handleSetSelectChange(selectedOption, index, 'RBI')}
                                            options={perRBIFields} // Provide the options for the current dropdown
                                            placeholder="Select Column"
                                            name={`status-${index}`} // Unique name for each select
                                            className={`mt-0 ${loanCss.scenarioSelect}`}
                                            classNamePrefix="select"
                                            styles={customStyles}
                                            isClearable={false}
                                            isSearchable={false}
                                        />
                                    </div>
                                ))}
                            </div>
                        :     
                        subMappingActiveTab === 2 ? 
                            <div className={`${loanCss.selectContainerWrapper} ${loanCss.customscroll}`}>
                                {perIndAsLabels?.map((label, index) => (
                                    <div className={loanCss.selectContainerTab} key={index}>
                                        <div style={{ marginBottom:'10px' }}>{label}</div>
                                        <Select
                                            components={{ IndicatorSeparator: () => null }} // remove separator
                                            key={index}
                                            value={selectedSubMappingData.IndASStages[index]?.values?.[0] 
                                                ? { label: selectedSubMappingData.IndASStages[index].values[0], value: selectedSubMappingData.IndASStages[index].values[0] }
                                                : null
                                            }
                                            onChange={(selectedOption) => handleSetSelectChange(selectedOption, index, 'IndAS')}
                                            options={perIndAsFields} // Provide the options for the current dropdown
                                            placeholder="Select Column"
                                            name={`status-${index}`} // Unique name for each select
                                            className={`mt-0 ${loanCss.scenarioSelect}`}
                                            classNamePrefix="select"
                                            styles={customStyles}
                                            isClearable={false}
                                            isSearchable={false}
                                        />
                                    </div>
                                ))}
                            </div>
                        :
                        subMappingActiveTab === 3 ? 
                            <div className={`${loanCss.selectContainerWrapper} ${loanCss.customscroll}`}>
                                {perProductClassfLables?.map((label, index) => (
                                    <div className={loanCss.selectContainerTab} key={index}>
                                        <div style={{ marginBottom:'10px' }}>{label}</div>
                                        <Select
                                            components={{ IndicatorSeparator: () => null }} // remove separator
                                            key={index}
                                            value={selectedSubMappingData.productClassificationStages[index]?.values?.[0] 
                                                ? { label: selectedSubMappingData.productClassificationStages[index].values[0], value: selectedSubMappingData.productClassificationStages[index].values[0] }
                                                : null
                                            }
                                            onChange={(selectedOption) => handleSetSelectChange(selectedOption, index, 'productClassification')}
                                            options={perProductClassfFields} // Provide the options for the current dropdown
                                            placeholder="Select Column"
                                            name={`status-${index}`} // Unique name for each select
                                            className={`mt-0 ${loanCss.scenarioSelect}`}
                                            classNamePrefix="select"
                                            styles={customStyles}
                                            isClearable={false}
                                            isSearchable={false}
                                        />
                                    </div>
                                ))}
                            </div>
                        : null
                    }
                </div>

                <div className={loanCss.cutModelFooterContainer}>
                    <button
                        type="button"
                        onClick={() => {setsubloanMapping(false)}}
                        className={loanCss.custModelFooterBtnSecondary}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        onClick={() => {saveSubMapping()}}
                        className={loanCss.custModelFooterBtnPrimary}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
  );
};



// export const customStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     borderColor: '#c2e6d1',
//     color: '#b3c0bd',
//     boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
//     borderWidth: '1px',
//     borderRadius: '10px',
//     '&:hover': {
//       borderColor: '#b3c0bd',
//     },
//     minHeight: '38px',
//     height: '38px'
//   }),
//   valueContainer: (provided) => ({
//     ...provided,
//     padding: '2px 8px',
//     paddingTop: '1px'
//   }),
//   input: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   placeholder: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     fontSize: "14px"
//   }),
//   singleValue: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//     fontSize: "14px"
//   }),
//   multiValue: (provided) => ({
//     ...provided,
//     backgroundColor: '#e0f5e9', // softer variant
//     borderRadius: '0.25rem',
//     border: '1px solid #c2e6d1',
//     width: 'fit-content'
//   }),
//   multiValueLabel: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//   }),
//   multiValueRemove: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       backgroundColor: '#c2e6d1',
//       color: '#4f665f',
//     },
//   }),
//   indicatorsContainer: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   dropdownIndicator: (provided, state) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   clearIndicator: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   menu: (provided) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     border: '1px solid #c2e6d1',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
//     borderRadius: '0.5rem',
//     zIndex: 10,
//   }),
//   menuList: (provided) => ({
//     ...provided,
//     padding: 0,
//   }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//         ? '#e9f7ef'
//         : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: "14px"
//   }),
//   noOptionsMessage: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     padding: '8px 12px',
//   }),
// };

// export const customStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     borderColor: '#c2e6d1',
//     color: '#b3c0bd',
//     boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
//     borderWidth: '1px',
//     borderRadius: '10px',
//     '&:hover': {
//       borderColor: '#b3c0bd',
//     },
//     minHeight: '38px',
//     height: '38px'
//   }),
//   valueContainer: (provided) => ({
//     ...provided,
//     padding: '2px 8px',
//     paddingTop: '1px'
//   }),
//   input: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   placeholder: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     fontSize: "14px"
//   }),
//   singleValue: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//     fontSize: "14px"
//   }),
//   multiValue: (provided) => ({
//     ...provided,
//     backgroundColor: '#e0f5e9',
//     borderRadius: '0.25rem',
//     border: '1px solid #c2e6d1',
//     width: 'fit-content'
//   }),
//   multiValueLabel: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//   }),
//   multiValueRemove: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       backgroundColor: '#c2e6d1',
//       color: '#4f665f',
//     },
//   }),
//   indicatorsContainer: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   dropdownIndicator: (provided, state) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   clearIndicator: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   menu: (provided) => ({
//     ...provided,
//     backgroundColor: '#ffffff',
//     border: '1px solid #c2e6d1',
//     borderRadius: '10px',
//     boxShadow: '0 0 0 1px #c2e6d1',
//     marginTop: '4px',
//     zIndex: 10,
//   }),
//   menuList: (provided) => ({
//     ...provided,
//     padding: 0,
//   }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//         ? '#f4faf5'
//         : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: "14px",
//     borderBottom: '1px solid #f4faf5',
//   }),
//   noOptionsMessage: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     padding: '8px 12px',
//   }),
// };


export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#205a46', 
    ':hover': {
        color: '#205a46',
    },
    }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '10px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '10px',
  }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//       ? '#f4faf5'
//       : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     borderRadius: '8px',
//     // margin: '4px 6px',
//   }),
option: (provided, state) => ({
  ...provided,
  backgroundColor: state.isFocused
    ? '#f4faf5'
    : 'transparent',
  color: '#4f665f',
  padding: '10px 12px',
  cursor: 'pointer',
  fontSize: '14px',
  borderRadius: '8px',
}),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};
